import NoDataPlaceholder from './NoDataPlaceholder'
import { HiOutlineChartBar } from 'react-icons/hi'
import { Paragraph } from '@eggplant/pattern-library'

const EmptyPerformanceChartState = () =>
  <NoDataPlaceholder
    icon={
      <HiOutlineChartBar
        aria-hidden
        size={24}
      />
    }
    title='No test case steps performance data available'
  >
    <Paragraph>
      Run the selected monitor config at least once to enable test case steps performance data.<br />
      Try adjusting your filter selections..
    </Paragraph>
  </NoDataPlaceholder>

export default EmptyPerformanceChartState
